import {
  Group,
  Assessment,
  DeviceHub,
  DisplaySettings,
  CheckBox as CheckBoxIcon,
  MiscellaneousServices,
  Home, Description, BarChart
} from "@mui/icons-material";
import PagePermBits from "./helpers/constants/PagePermBits";
import RouteUrls from "./helpers/urls/RouteUrls";

import Dashboard from "./routes/dashboard";

import UserManagement from "./routes/users/pages/list";
import AddUser from "./routes/users/pages/add";

import AddDomain from "./routes/domains/pages/add";
import DomainManagement from "./routes/domains/pages/list";
import EditDomain from "./routes/domains/pages/edit";

import AddSite from "./routes/sites/pages/add";

import Commit from "./routes/commit/pages/list";
import DefaultParams from "./routes/default-params";
import SiteManagement from "./routes/sites/pages/list";
import Charts from "./routes/reports/pages/charts";
import Statistics from "./routes/reports/pages/statistics";

const userType = JSON.parse(localStorage.getItem("user"))?.type;

const routes = [
  {
    type: "menu_link",
    route: RouteUrls.dashboard,
    name: "داشبورد",
    key: "dashboard",
    permission: PagePermBits.dashboard,
    icon: <Home sx={{ fontSize: 20 }} />,
    component: <Dashboard />,
  },
  {
    type: "menu_link",
    route: RouteUrls.domain.list,
    name: "مدیریت دامنه‌ها",
    key: "domain-management",
    permission: PagePermBits.domainManagement,
    icon: <DeviceHub sx={{ fontSize: 20 }} />,
    component: <DomainManagement />,
  },
  {
    type: "route",
    route: RouteUrls.domain.add,
    key: "add-domain",
    permission: PagePermBits.domainManagement,
    component: <AddDomain />,
  },
  {
    type: "route",
    route: RouteUrls.domain.edit,
    key: "edit-domain",
    permission: PagePermBits.domainManagement,
    component: <EditDomain />,
  },
  {
    type: "menu_link",
    route: "/site/list",
    name: "مدیریت سایت‌ها",
    key: "site-management",
    permission: PagePermBits.siteManagement,
    icon: <DisplaySettings sx={{ fontSize: 20 }} />,
    component: <SiteManagement />,
  },
  {
    type: "route",
    route: RouteUrls.site.add,
    key: "add-site",
    permission: PagePermBits.siteManagement,
    component: <AddSite />,
  },
  {
    type: "menu_link",
    route: RouteUrls.user.list,
    name: "مدیریت کاربران",
    key: "user-management",
    permission: PagePermBits.userManagement,
    icon: <Group sx={{ fontSize: 20 }} />,
    component: <UserManagement />,
  },
  {
    type: "route",
    route: RouteUrls.user.add,
    key: "add-user",
    permission: PagePermBits.userManagement,
    component: <AddUser />,
  },
  {
    type: "title",
    name: "گزارش‌ها",
    permission: PagePermBits.reports,
    key: [RouteUrls.report.chart, RouteUrls.report.statistic],
    icon: <Assessment sx={{ fontSize: 22 }} />,
    collapse: [
      {
        type: "collapse",
        route: RouteUrls.report.chart,
        name: "نمودار",
        key: "report-chart",
        permission: PagePermBits.reports,
        icon: <BarChart sx={{ fontSize: 20 }} />,
        component: <Charts />,
      },
      {
        type: "collapse",
        route: RouteUrls.report.statistic,
        name: "آمار",
        key: "report-statistic",
        permission: PagePermBits.reports,
        icon: <Description sx={{ fontSize: 20 }} />,
        component: <Statistics />,
      }
    ],
  },
  {
    type: "menu_link",
    route: "/set-parameters",
    name: "تنظیم پارامترهای سیستم",
    key: "set-parameters",
    permission: PagePermBits.setParameters,
    icon: <MiscellaneousServices />,
    component: <DefaultParams />,
  },
  {
    type: "menu_link",
    route: RouteUrls.commit,
    name: "اجرای تغییرات",
    key: "commit",
    permission: PagePermBits.commit,
    icon: <CheckBoxIcon />,
    component: <Commit />,
  },
];

export default routes;
